module.exports = __webpack_public_path__ + "static/media/ecuador.91985111.svg";